import React, { useState, useEffect } from 'react';
import { Link, Route, useHistory } from 'react-router-dom';
import Badge from 'react-bootstrap/Badge';
import PermEnLigne from './PermEnLigne';
import Departement_perm from './Departement_perm';
import EmailTelCandidat from './EmailTelCandidat';
import AnMatSess from './AnMatSess_perm';
import InfoAnMatSess_perm from './InfoAnMatSess_perm';
import Siege_perm from './Siege_perm';
import Bunexe_service from './../../Bunexe_service';

import AnMatSess_perm from './AnMatSess_perm';
import Resume_perm from './Resume_perm';
// import MyDocument from './MyTestComponent';
import TestSalutation from '../secIV/souscomposants/TestSalutation';
import MyTestComponent from './MyTestComponent';
import Mode_paiement from './Mode_paiement';
import InfoTransaction from './InfoTransaction';

const Bienvenue_perm = ({ info }) => {
  const histo = useHistory();
  const [currentform, setCurrentform] = useState(0);
  const [methode_paiement, setMethode_paiement] = useState('0');
  /**
   *  0 == Paimenent a la BNC
   *  1 == Paiment Lajan Cash
   *  2 == Paiement MonCash
   */
  const [departement, setDepartement] = useState('01');
  const [siege_, setSiege_] = useState('');
  const [sieges, setSieges] = useState([]);
  const [infoPh, setInfoPh] = useState([]);
  const [candidatSelectionne, setCandidatSelectionne] = useState({});
  const [email, setEmail] = useState('');
  const [tel, setTel] = useState('');

  let depTemp = undefined;
  let siegeTemp = undefined;

  let url_ = Bunexe_service.url;

  const init = () => {
    setSieges([]);
    setInfoPh([]);
    setCandidatSelectionne({});
    setSiege_('');
    setEmail('');
    setTel('');
    setCurrentform(0);
    setMethode_paiement('0');
  };

  const setDepartement_ = async (d) => {
    // let kk = Bunexe_service.depts.filter((d1) => d1.code == d)[0];
    // depTemp = kk;
    // alert(JSON.stringify(depTemp));
    //alert(d);
    // depTemp = {
    //   ...depTemp,
    //   ...Bunexe_service.depts.filter((d1) => d1.code == d),
    // };
    // init();
    setDepartement(d);
    await getSiege(d);
    //setSiege_('');
  };

  const getSiege = async (d) => {
    // setAlreadyLoaded(false);
    try {
      fetch(url_ + `/recherche/perm_en_ligne/${d}/siege`)
        .then((response) => response.json())
        .then((data) => {
          setSieges(data);
          if (data.length > 0) {
            //if (siege_ == '')
            setSiege_(data[0].IDSIEGE);
            //else setSiege_(siege_);

            siegeTemp = {
              ...siegeTemp,
              ...sieges.filter((s) => s.IDSIEGE == siege_),
            };
          }
          //setAlreadyLoaded(true);
        })
        .catch((err) => console.log(err));
    } catch (error) {
      console.log(error);
    }
  };

  const affiche_etapes = () => {
    switch (currentform) {
      case 0:
        return (
          <PermEnLigne
            setCurrentform={setCurrentform}
            currentform={currentform}
          />
        );

      case 1:
        return (
          <EmailTelCandidat
            setCurrentform={setCurrentform}
            currentform={currentform}
            email={email}
            setEmail={setEmail}
            tel={tel}
            setTel={setTel}
          />
        );

      case 2:
        return (
          <Departement_perm
            setCurrentform={setCurrentform}
            currentform={currentform}
            departement={departement}
            setDepartement_={setDepartement_}
          />
        );

      case 3:
        return (
          <Siege_perm
            setCurrentform={setCurrentform}
            currentform={currentform}
            siege_={siege_}
            setSiege_={setSiege_}
            sieges={sieges}
          />
        );

      case 4:
        return (
          <AnMatSess_perm
            setCurrentform={setCurrentform}
            currentform={currentform}
            infoPh={infoPh}
            setInfoPh={setInfoPh}
            candidatSelectionne={candidatSelectionne}
            setCandidatSelectionne={setCandidatSelectionne}
          />
        );
      case 5:
        return (
          <Mode_paiement
            setCurrentform={setCurrentform}
            currentform={currentform}
            infoPh={infoPh}
            setInfoPh={setInfoPh}
            candidatSelectionne={candidatSelectionne}
            setCandidatSelectionne={setCandidatSelectionne}
            methode_paiement={methode_paiement}
            setMethode_paiement={setMethode_paiement}
          />
        );
      case 6:
        return (
          <InfoTransaction
            setCurrentform={setCurrentform}
            currentform={currentform}
            infoPh={infoPh}
            setInfoPh={setInfoPh}
            candidatSelectionne={candidatSelectionne}
            setCandidatSelectionne={setCandidatSelectionne}
            methode_paiement={methode_paiement}
            setMethode_paiement={setMethode_paiement}
          />
        );
      case 7:
        return (
          <Resume_perm
            setCurrentform={setCurrentform}
            currentform={currentform}
            candidatSelectionne={candidatSelectionne}
            departement={departement}
            siege_={siege_}
            sieges={sieges}
            info={info}
            email={email}
            tel={tel}
            methode_paiement={methode_paiement}
            setMethode_paiement={setMethode_paiement}
          />
        );

      default:
        return <MyTestComponent />;
    }
  };
  useEffect(() => {
    init();
  }, []);
  useEffect(() => {
    setDepartement_(departement);
  }, [departement]);
  return (
    <div className='container mb-3'>
      {/* <div
        className='d-flex justify-content-center align-items-center'
        style={{ marginTop: 20 }}
      > */}
      {currentform > 0 && (
        <div className='mt-3 d-flex justify-content-center'>
          <div>
            <Badge variant={currentform == 1 ? 'info' : 'secondary'}>
              <span style={{ fontSize: '12px', margin: '10px' }}>
                Telephone
              </span>
            </Badge>{' '}
            <Badge variant={currentform == 2 ? 'info' : 'secondary'}>
              <span style={{ fontSize: '12px', margin: '10px' }}>
                Departement
              </span>
            </Badge>{' '}
            <Badge variant={currentform == 3 ? 'info' : 'secondary'}>
              <span style={{ fontSize: '12px', margin: '10px' }}>Siège</span>
            </Badge>{' '}
            <Badge variant={currentform == 4 ? 'info' : 'secondary'}>
              <span style={{ fontSize: '12px', margin: '10px' }}>
                Info. Fiche
              </span>
            </Badge>{' '}
            <Badge variant={currentform == 5 ? 'info' : 'secondary'}>
              <span style={{ fontSize: '12px', margin: '10px' }}>Paiement</span>
            </Badge>{' '}
            <Badge variant={currentform == 6 ? 'info' : 'secondary'}>
              <span style={{ fontSize: '12px', margin: '10px' }}>
                Info Transaction
              </span>
            </Badge>{' '}
            <Badge variant={currentform == 7 ? 'info' : 'secondary'}>
              <span style={{ fontSize: '12px', margin: '10px' }}>Résumé</span>
            </Badge>
          </div>
        </div>
      )}

      {affiche_etapes()}
      {/* </div> */}
    </div>
  );
};

export default Bienvenue_perm;
